import { SpecificRulesProduct } from '@teinor/erp/prices/types';
import { ProductModelType } from '@teinor/erp/types/company/product';
import { connect, ConnectedProps } from 'react-redux';
import { ComponentWithPermissions } from '../../../../../../../../../../baseComponents/CreateRoutering/types';
import DisplayPrice from '../../../../../../../../../../baseComponents/Displays/DisplayPrice';
import { CalculateParamsTy } from '../../../../../../../../../../baseComponents/Displays/DisplayPrice/types';
import { TitleSButtonPermissioned } from '../../../../../../../../../../baseComponents/Layout/TitleAndRightLayout';
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types';
import VirtualTableListing from '../../../../../../../../../../baseComponents/TwinTable/VirtualTableListing';
import { CustomRenderBoolean, CustomRenderString } from '../../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders';
import { ColumnTableSchema } from '../../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types';
import { RectangularInput, RectangularInputFormatNumberSmall } from '../../../../../../../../../../forms/Input';
import { replaceDotsForDecimalSeparator } from '../../../../../../../../../../utils/globals/numbers';
import withLoading from '../../../../../../../../../../utils/hoc/withLoading';
import useSpecifcPricesProduct from '../../../../../../../../../../utils/hooks/product/useSpecificPriceProduct';
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation';
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers';
import { getPreparePricesConfigParam } from '../../../../../../../../../../utils/reducers/getters';
import { SpecificPriceRulesPayload } from '../../../../../../../../../../utils/reducers/products/specificPriceRules';
import { pricesRowRender } from '../../../../../../../../../Price/DisplayPrice';

type SpecificPricesProductTabProps = ModalEditComponentProps & ReduxSpecificPricesProductTab & ComponentWithPermissions & {
    basicData: ProductModelType
}

const SpecificPricesProductTab: React.FC<SpecificPricesProductTabProps> = ({basicData, specificPriceRules}) => {
    const {t} = useTwinTranslation()
    const { data } = useSpecifcPricesProduct({ ProductId: basicData.id })
    const calculateParamsDefault = getPreparePricesConfigParam() as CalculateParamsTy
    const columns: ColumnTableSchema<SpecificRulesProduct> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            customRender: (parameterValue) => <CustomRenderString value={'T'+parameterValue} />,
            width: 50
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre')
        },
        {
            id: 'units',
            dataKey: 'units',
            label: t('units', 'Unidades'),
            width: 75,
            customRender: (parameterValue) => <RectangularInputFormatNumberSmall value={parameterValue ?? 1} readOnly={true} className='w-60' />,
        },
        {
            id: 'is_pack',
            dataKey: 'is_pack',
            label: t('is_pack', 'Es un pack'),
            width: 100,
            customRender: (parameterValue) =><CustomRenderBoolean value={String(parameterValue) === 'true'} width={70} />,
        },
        {
            id: 'price',
            dataKey: 'price',
            label: t('priceOrFormula', 'Precio o formula'),
            customRender: (parameterValue, allRowData) => <RectangularInput className='mr-10' value={replaceDotsForDecimalSeparator(parameterValue ?? allRowData.formula ?? '') } readOnly={true} />,
            width: 150,
        },
        {
            id: 'calculated_price',
            dataKey: 'calculated_price',
            label: t('finalPrice', 'Precio final'),
            customRender: (parameterValue, allRowData) => <DisplayPrice value={parseFloat(parameterValue)} CurrencyId={specificPriceRules?.dictionary[allRowData.SpecificPriceRuleId]?.CurrencyId || 'EUR'} with_vat={false} calculateParams={{
                decimals: allRowData?.decimals,
                rounding: allRowData?.rounding,
                roundingPriceType: calculateParamsDefault?.roundingPriceType
            }} />
        }
    ]
    return (
        <TitleSButtonPermissioned title={t('productPrice', 'Precios del producto')} buttonText={t('save', 'Guardar')} userPermissions={{n: 1, permission: 'read'}} permission='update'>
            <div className='flex-auto'>
                <VirtualTableListing tableData={data} columns={columns} rowRenderer={pricesRowRender} name='specificPricesProductTab'/>
            </div>
        </TitleSButtonPermissioned>
    )
}

const specificPricesProductTabDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

type ReduxSpecificPricesProductTab = ConnectedProps<typeof specificPricesProductTabConnect>
const mapSpecificPricesProductTabConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const specificPricesProductTabConnect = connect(mapSpecificPricesProductTabConnector, specificPricesProductTabDispatch)

const specificPricesProductTabConnectLoading = withLoading(SpecificPricesProductTab, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const SpecificPricesProductTabConnect = specificPricesProductTabConnect(specificPricesProductTabConnectLoading)

export default SpecificPricesProductTabConnect